import { ReactNode, useEffect, useState } from 'react'
import { m, AnimatePresence } from 'framer-motion'
import { cn } from '@/utils/helpers'
import { createPortal } from 'react-dom'

interface AnimatedModalProps {
  isOpen: boolean
  onClose: () => void
  children: ReactNode
  className?: string
}

export function AnimatedModal({ isOpen, onClose, children, className = 'max-w-2xl' }: AnimatedModalProps) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <m.div
          className="fixed inset-0 z-[9999] flex items-center justify-center p-2 sm:p-4 bg-black/60 backdrop-blur-sm"
          onClick={onClose}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <m.div
            className={cn(
              "mt-2 sm:mt-3 bg-white rounded-3xl w-full max-h-[calc(100dvh-5rem)] sm:max-h-[calc(100dvh-6rem)] overflow-hidden flex flex-col shadow-2xl",
              className
            )}
            initial={{ scale: 0.95, y: 20 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.95, y: 20 }}
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </m.div>
        </m.div>
      )}
    </AnimatePresence>,
    document.body
  )
}
